import type { AvatarResponseObject, GetAvatarsResponse } from '../../common/types';

export const refineGetAvatarsResponse = (obj: unknown): GetAvatarsResponse => {
	if (
		!obj ||
		typeof obj !== 'object' ||
		!('system' in obj) ||
		!Array.isArray(obj.system) ||
		!('custom' in obj) ||
		!Array.isArray(obj.custom)
	) {
		throw new Error('Unexpected shape of GetAvatarsResponse');
	}

	const refinedSystemAvatars: Array<AvatarResponseObject> = obj.system.map(
		refineAvatarResponseObject,
	);

	const refinedCustomAvatars: Array<AvatarResponseObject> = obj.custom.map(
		refineAvatarResponseObject,
	);

	return {
		system: refinedSystemAvatars,
		custom: refinedCustomAvatars,
	};
};

export const refineAvatarResponseObject = (obj: unknown): AvatarResponseObject => {
	if (
		!obj ||
		typeof obj !== 'object' ||
		!('id' in obj) ||
		typeof obj.id !== 'string' ||
		!('isDeletable' in obj) ||
		typeof obj.isDeletable !== 'boolean' ||
		!('isSelected' in obj) ||
		typeof obj.isSelected !== 'boolean' ||
		!('isSystemAvatar' in obj) ||
		typeof obj.isSystemAvatar !== 'boolean' ||
		!('urls' in obj) ||
		typeof obj.urls !== 'object' ||
		!obj.urls ||
		!('16x16' in obj.urls) ||
		typeof obj.urls['16x16'] !== 'string' ||
		!('24x24' in obj.urls) ||
		typeof obj.urls['24x24'] !== 'string' ||
		!('32x32' in obj.urls) ||
		typeof obj.urls['32x32'] !== 'string' ||
		!('48x48' in obj.urls) ||
		typeof obj.urls['48x48'] !== 'string'
	) {
		throw new Error('Unexpected shape of Avatar');
	}

	return {
		id: obj.id,
		isDeletable: obj.isDeletable,
		isSelected: obj.isSelected,
		isSystemAvatar: obj.isSystemAvatar,
		urls: {
			'16x16': obj.urls['16x16'],
			'24x24': obj.urls['24x24'],
			'32x32': obj.urls['32x32'],
			'48x48': obj.urls['48x48'],
		},
	};
};
